module.exports = __webpack_public_path__ + "img/9.3cd4f1dc.png";